import { render, staticRenderFns } from "./SalesShipmentsPrintBOL.vue?vue&type=template&id=e8512164&"
import script from "./SalesShipmentsPrintBOL.vue?vue&type=script&lang=js&"
export * from "./SalesShipmentsPrintBOL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports